import { HttpError, http } from './handler';

export function getTask<T>(url: string): Promise<{ response?: T; error?: HttpError }> {
  const options: RequestInit = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  };
  return fetch(url, options)
    .then(http)
    .then(response => ({ response }))
    .catch(error => ({ error }));
}

export function postTask<T>(url: string, body: object): Promise<{ response?: T; error?: HttpError }> {
  const options: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body ? { ...body } : {}),
  };
  return fetch(url, options)
    .then(http)
    .then(response => ({ response }))
    .catch(error => ({ error }));
}

export function deleteTask<T>(url: string, body: object): Promise<{ response?: T; error?: HttpError }> {
  const options: RequestInit = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body ? { ...body } : {}),
  };
  return fetch(url, options)
    .then(http)
    .then(response => ({ response }))
    .catch(error => ({ error }));
}
